@if (showSignupSuccessBanner) {
  <div class="mb-4">
    <app-edit-permissions-banner [bannerType]="BannerType.check" (onClose)="closeSignupSuccessBanner()">
      {{ 'sign_up_success' | translate }}
    </app-edit-permissions-banner>
  </div>
}

<div class="mb-4">
  {{ 'sign_up_platform_usage_description' | translate }}
</div>

<div class="mb-4">
  <ds-checkbox-group
    #platFormActionCheckboxGroup
    [label]="'sign_up_platform_usage_checkbox_label' | translate"
    [instructions]="'sign_up_platform_usage_checkbox_instruction' | translate"
    [hideSelectAll]="true"
    data-test-id="sign-up-platform-action-checkbox-group"
  >
    @for (platformAction of platformActions; track platformAction.labelKey) {
      <ds-checkbox
        [checkboxId]="platformAction.value"
        [value]="platformAction.value"
        [label]="platformAction.labelKey | translate"
        [attr.data-test-id]="platformAction.value"
      ></ds-checkbox>
    }
  </ds-checkbox-group>
</div>

<div>
  <button type="button" ds-button [variant]="DsButtonVariants.primary" (click)="onSubmit()" data-test-id="sign-up-submit">
    {{ 'label_next' | translate }}
  </button>
</div>
